<template>
	<div class='route_container'>
		<div class="main_container py-5 px-5 mt-5">
			<div class="row">
				<!-- category sidebar -->
				<div class="col-lg-3 filter-column pr-lg-3 px-0">
					<fancy-input
						:placeholder='`${ $t("gifts_search") }...`'
						v-model='searchDiscussion'
						type="text"
						aria-label="Search"
						ref="search"
						:large='true'
					></fancy-input>
					<ul id="filtersList" class="nav accordion d-flex flex-column flex-nowrap bg-gray-900 border border-green-lighter border-top-0  box-shadow my-3">
						<li class="nav-item py-3">
							<div class="d-flex row align-items-center justify-content-between m-0 px-2">
								<div class="categories-title d-flex row align-items-center col-11">
									<p class="h6 text-white mb-0 py-2">Category</p>
								</div>
							</div>
							<router-link
								v-for='(category, $index) in categories'
								:key='"category-link-" + $index'
								class='threads_main__side_bar__menu_item'
								:to="`/${$store.state.meta.lang}/discussions/${category.value}`"
							>
								<span
									class='threads_main__side_bar__menu_item__border'
								></span>
								<span
									class='threads_main__side_bar__menu_item__text'
								>{{category.name}}</span>
							</router-link>
						</li>
					</ul>
				</div>
				<div class="col-lg-9 pl-lg-3 px-0 pb-3">
					<h2 class="border-bottom border-green-lighter"> 
						{{ $t('gifts_discussions') }} > General > {{ decodeURIComponent($route.params.title) }}
					</h2>
					<thread-poll
						v-if="drawDiscussion.poll"
						:poll="drawDiscussion.poll"
					></thread-poll>
					<div class="comments border border-green-lighter my-3 px-3">
						<div v-if="waitLoading" class="table__row-inner-wrap justify-content-center m-auto">
							<loading-button									
								:loading='waitLoading'
								class='nav-link m-auto'
							>
								<font-awesome-icon icon="spinner"/>
							</loading-button>
						</div>						
						<div v-else class="comment">
							<div class="comment__parent">
								<router-link 
									:to="`/${$store.state.meta.lang}/user/${drawDiscussion.creator}`" 
									class="giveaway_image_avatar" 
									:style="drawDiscussion.creator_avatar?{ 'background-image': 'url(' + drawDiscussion.creator_avatar + ')' }:{ 'background-image': 'url(' + missed_avatar + ')' }"
								></router-link>
								<div class="comment__summary">
									<div class="comment__author">
										<a href="javascript:void(0)" v-b-toggle="'accordion_' + drawDiscussion.creator_id">
											<span class="when-opened">
												<font-awesome-icon :icon="['fa','minus-square']" />
											</span>
											<span class="when-closed">
												<font-awesome-icon :icon="['fa','plus-square']" />
											</span>
										</a>
										<a :href="`/${$store.state.meta.lang}/user/${drawDiscussion.creator}`">{{drawDiscussion.creator}}</a>
									</div>
									<b-collapse visible class="comment__display-state" :id="'accordion_' + drawDiscussion.creator_id">
										<div class="comment__description markdown markdown--resize-body">
											<p>{{drawDiscussion.description}}</p>
											<div class="comment__actions">
												<div class="mt-1"><span>{{drawDiscussion.created_at | localTime | formatDate}}</span> {{ $t('gifts_ago') }} </div>
											</div>
										</div>
									</b-collapse>
								</div>
							</div>
						</div>
					</div>
					<h4 class="border-bottom border-green-lighter"> {{ $store.state.meta.comments.length }} comments </h4>
					<div class="comments border border-green-lighter my-3 px-3">
						<div class="comments">	
							<recursive-component v-for="(child, index) in $store.state.meta.comments" 
												:comment='child'
												:key="index"
												@replyTo="replyMe($event)"
												>
							</recursive-component>
						</div>
						<span v-if="error.parent_id" class="text-danger">*{{ $t('gifts_select_section_answer') }}</span>						
					</div>

					<!-- submit form ==>> -->
					<div v-if="$store.state.username.length" class="comments border border-green-lighter my-3 p-3">
						<div class="row text-center">
							<!-- <h6 class="text-info">Reply to: </h6> -->
						</div>
						<div class="row">									
							<div class="col-1 justify-content-center align-items-center m-auto text-center">
								<router-link :to="`/${$store.state.meta.lang}/user/${$store.state.username}`" 
									class="giveaway_image_avatar m-auto" 
									:style="$store.state.profile_photo_path ?
									{ 'background-image': `url(${apiDomain}/uploads/avatar/${$store.state.profile_photo_path})` }:
									{ 'background-image': 'url(' + missed_avatar + ')' }"
								></router-link>
								<router-link :to="`/${$store.state.meta.lang}/user/${$store.state.username}`" >
									{{ $store.state.username }}
								</router-link>
							</div>										
							<div class="col-11">								
								<textarea class="form-control" v-model="content"></textarea>
								<span v-if="error.content" class="text-danger">*{{ $t('gifts_introduce_comment') }}</span>
								<p v-if="!!error.msg" class="text-danger">*{{ error.msg }}</p>
							</div>							
						</div>
						<div class="row">
							<div class="col-1"></div>
							<div class="col-11 mt-4">
								<button v-if=" submit_comment_type==='save' " class="btn btn-primary btn-md rounded" @click="saveComment">
									<loading-button
										v-if="creationLoading"
										:loading='creationLoading'
										class='nav-link'
									>
										<font-awesome-icon icon="spinner"/>
									</loading-button>										
									<span v-else >
										<span>{{ $t('gifts_add_comment') }}</span>
									</span>
								</button>
								<button v-else class="btn btn-primary btn-md rounded" @click="updateComment">
									<loading-button
										v-if="creationLoading"
										:loading='creationLoading'
										class='nav-link'
									>
										<font-awesome-icon icon="spinner"/>
									</loading-button>										
									<span v-else >
										<span>{{ $t('gifts_update_comment') }}</span>
									</span>
								</button>
							</div>
						</div>
					</div>
					<!-- << -->
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import FancyInput from '../FancyInput'
	import {apiDomain} from '../../config'
	import LoadingButton from '../LoadingButton';
	import RecursiveComponent from '../RecursiveComponent';
	import ThreadPoll from '../ThreadPoll'

	export default {
		name: 'discussion',
		components: {
			FancyInput,
			LoadingButton,
			RecursiveComponent,
			ThreadPoll
		},
		data () {
			return {
				creationLoading: false,
				waitLoading: false,
				parentID: 0,
				apiDomain: apiDomain,
				hero_img: require("./../../assets/img/new-home/header.jpg"),
				choosed_color: "#00ff7f",
				choosed_back_color: "#00ff7f",
				discussion: {},
				drawDiscussion: {},
				storeAllComments:{},
				content: "",
				submit_comment_type: 'save',
				submit_comment_id: 0,
				categories: [
					{ "name": "All", "value": ""},
					{ "name": "Add-ons / Tools", "value": "addons-tools"}, 
					{ "name": "Announcements", "value": "announcements"},
					{ "name": "Bugs / Suggestions", "value": "bugs-suggestions"},
					{ "name": "Deals", "value": "deals"},
					{ "name": "Game Showcase", "value": "game-showcase"},
					{ "name": "General", "value": "general"},
					{ "name": "Group Recruitment", "value": "group-recruitment"},
					{ "name": "Hardware", "value": "hardware"},
					{ "name": "Help", "value": "help"},
					{ "name": "Let's Play Together", "value": "lets-play-together"},
					{ "name": "Movies / TV", "value": "movies-tv"},
					{ "name": "Off Topic", "value": "off-topic"},
					{ "name": "Puzzles / Events", "value": "puzzles-events"},
					{ "name": "Uncategorized", "value": "uncategorized"},
					{ "name": "User Projects", "value": "user-projects"},
					{ "name": "Whitelist Recruitment", "value": "whitelist-recruitment"}
				],
				searchDiscussion: "",
				missed_avatar: require("./../../assets/img/new-home/missed_avatar.jpg"),
				error: {
					parent_id : false,
					content: false,
					msg: ''
				},
				comments:[]
			}
		},
		created(){
			let discussionID = this.$route.params.id;

			this.waitLoading = true;

			this.axios.request({
				method: 'GET',
				url: `${apiDomain}/api/v1/discussion/${discussionID}`,
				data: {},
				headers: {
					'Authorization': `Bearer ${this.$cookies.get('authtoken')}`
				}
			}).then(res => {
				
				this.waitLoading = false;
				this.init(res);	

			}).catch(err => {				
				this.waitLoading = false;						
				console.log(err)
			})

		},
		watch: {
			searchDiscussion: function(sKey){
				let cmts = [];
				if(!!sKey){
					cmts = this.storeAllComments.filter( x => x.content.toLowerCase().includes(sKey.toLowerCase()) );
				}else{
					cmts = this.storeAllComments;
				}
				this.$store.commit('setComments', cmts);
			}
		},
		methods: {
			init: function(res){	
				function loops(dd){
					dd.forEach((element, i) => {
						element['select'] = false						
						element.all_children.length && loops(element.all_children)
					});
					return dd
				}
				this.drawDiscussion = {...res.data.content, select: false};

				this.drawDiscussion.all_children.length && loops(this.drawDiscussion.all_children);

				this.storeAllComments = this.drawDiscussion.all_children;				

				this.$store.commit('setComments', this.storeAllComments);
				//
				res.data.content.message && this.$store.commit('setNmessages', res.data.content.message)
			},
			saveComment: function(e){				
				
				if(!this.content){ this.error.content = true; return false; } 
				if(this.content){ this.error.msg = ""; }

				this.creationLoading = true;

				this.axios.post(`${apiDomain}/api/v1/comments`,
					{	parent_id: this.parentID, 
						discussion_id: this.$route.params.id,
						content: this.content
					},
					{ 
						headers: { 'Authorization': `Bearer ${this.$cookies.get('authtoken')}`} 
					}
				).then(res => {
					
					this.creationLoading = false;
					this.content = "";
					this.parent_id = 0;

					if(res.data.response == 'success'){
						this.init(res);
					}else{
						this.error.msg = res.data.content;
					}
					
				}).catch(err => {
					
					console.log(err)
					this.$router.push('/');
				})
			},
			removeComment: function(comment_id){
				
				this.creationLoading = true;

				this.axios.request({
                    method: 'delete',
                    url: `${apiDomain}/api/v1/comments/${comment_id}`,
                    headers: {
                        'Authorization': `Bearer ${this.$cookies.get('authtoken')}`
                    }
                }).then(res => {
					
					this.creationLoading = false;
					this.content = "";
					this.parent_id = 0;

					if(res.data.response == 'success'){
						this.init(res);
					}else{
						this.error.msg = res.data.content;
					}
					
				}).catch(err => {
					
					console.log(err)
					this.$router.push('/');
				})
			},
			updateComment: function(){
				
				
				if(!this.content){ this.error.content = true; return false; } 
				if(this.content){ this.error.msg = ""}
				
				this.creationLoading = true;

				this.axios.put(`${apiDomain}/api/v1/comments/${this.submit_comment_id}`,
					{ content: this.content },
					{ headers: { 'Authorization': `Bearer ${this.$cookies.get('authtoken')}`} }
				).then(res => {
					this.creationLoading = false;
					this.content = "";
					this.parent_id = 0;

					this.submit_comment_type = 'save';
					this.submit_comment_id = 0;

					if(res.data.response == 'success'){
						this.init(res);
					}else{
						this.error.msg = res.data.content;
					}
					
				}).catch(err => {
					
					console.log(err)
					this.$router.push('/');
				})
			},
			replyMe: function(data){
				
				if(data.type == 'remove'){
					this.removeComment(data.cid);
					return;
				}else if(data.type == 'edit'){
					
					this.content = data.content;
					this.submit_comment_type = 'edit';	
					this.submit_comment_id = data.cid;	
				}else{
					this.parentID = data.cid;
				}

				this.error.parent_id = false;
				this.error.msg = "";
				this.error.content = false;			

				// this.$store.commit('setComments', data.cmts);
			},			
		},
		computed: {	
			'$store.state.meta.comments': function(data){
			}
		}
	}
</script>

<style lang='scss' scoped>
	@import '../../assets/scss/elementStyles.scss';
	@import '../../assets/scss/variables.scss';
	@import '../../assets/scss/idec.scss';

	.router-link-exact-active span:first-child {
		background-color: $color__green--primary;
	}

	.router-link-exact-active span:last-child {
		color: $color__green--primary;
	}

	.threads_main {
		display: flex;

		&__side_bar{
			width: 12rem;
			height: 0%;
			background: #fff;
			margin-right: 1rem;
			border-radius: 0.25rem;
			border: thin solid $color__gray--darker;
			padding: 0.5rem 0 1rem 1rem;
			position: sticky;
			top: 4.5rem;

			@at-root #{&}__title {
				color: $color__darkgray--darker;
				cursor: default;
				font-weight: 500;
				font-size: 1.125rem;
			}

			@at-root #{&}__menu_item {
				cursor: pointer;
				margin-top: 0.5rem;
				position: relative;
				display: grid;
				grid-template-columns: 0.75rem auto;
				grid-column-gap: 1rem;
				text-decoration: none;
				background-image: none;
				font-weight: normal;
				margin-left: 1.5rem;

				span{
					color: #fff;
				}

				@at-root #{&}__border {
					align-self: center;
					display: inline-block;
					height: 0.9rem;
					width: 0.9rem;
					border-radius: 0.5rem;
					margin-top: 0;
					background-color: $color__gray--darkest;
					transition: all 0.2s;
				}

				@at-root #{&}__text {
					filter: saturate(0.75), brightness(0.75);
				}


				@at-root #{&}--selected {
					font-weight: 600;
				}
			}
		}

		&__load_new{
			@extend .button;

			font-size: 1.25rem;
			margin: 0 0 1rem 0;
			background-color: $color__lightgray--primary;
			border-color: $color__gray--darker;
			width: 100%;
			font-weight: 300;
		}
	}

	.comments{
		.comment{
			margin: 1rem 0;
			border-bottom: 1px solid $color__gray--darker;

			&:last-child{
				border-bottom: none;
			}

			&__parent, &__child, &__entity{
				max-width: 850px;
				display: flex;
			}

			&__children{
				margin-left: 50px;
			}

			.global__image-outer-wrap--avatar-small{
				height: 32px;
				width: 32px;
			}

			&__child{
				border: 1px solid $color__lightgray--primary;
				border-radius: 4px;
				padding: 15px;
			}

			&__actions{
				display: flex;
			}

			.global__image-outer-wrap--avatar-small{
				margin-right: 10px;
			}

			&__children:not(.comment__children--no-indent){
				padding-left: 25px;
				border-left: 1px solid #d2d6e0;
			}

			.giveaway_image_avatar{
				margin-right: 1rem;
			}

			&__summary{
				padding-bottom: 0.5rem;
				
				.comment__author{
					color: $color__green--primary;
					margin-bottom: 5px;
					display: flex;

					svg{
						margin-top: -1px;
						margin-right: 0.5rem;

						&:focus, &:hover{
							cursor: pointer;
							outline: none;
						}
					}
				}
			}
			.nav__avatar-inner-wrap, .global__image-inner-wrap{
				background-position: center center;
				background-repeat: no-repeat;
				background-size: cover;
				height: 100%;
				width: 100%;
				border-radius: 2px;
			}
		}
	}

	.collapsed > .when-opened,
    :not(.collapsed) > .when-closed {
        display: none;
    }

	@media (max-width: $breakpoint--tablet) {
		.main_container{
			margin-top: 0!important;
						
			.threads_main__side_bar {
				display: none;
			}
			.threads_main__threads {
				width: 100%;
				margin-left: 0;
			}
		}
	}
</style>
